export const uploadStatus = {
  init: 0,
  startLoading: 1,
  success: 2,
  fail: 3
}

export const supportFileTypes = ['wbmp', 'gif', 'jpeg', 'png', 'jpg', 'webp']
